var render = function render(){var _vm=this,_c=_vm._self._c;return _c('read-article',{attrs:{"article":_vm.news,"share-on-network":"","galleries":_vm.galleries}})
}
var staticRenderFns = []

export { render, staticRenderFns }